module.exports = "images/sport_tennis.fce6a9a02c651980bdd56a02151cc0c9.png";